import DashboardComp from 'components/Dashboard/DashboardComp'
import { useUser } from 'contexts/UserContext'
import {
  LuBuilding2,
  LuClipboardList,
  LuFileText,
  LuLeaf,
  LuUsers,
  LuWallet
} from 'react-icons/lu'

export default function DashboardPage() {
  const { user } = useUser()

  const cards = [
    {
      icon: <LuUsers size={28} />,
      title: "Gestió d'Usuaris",
      description:
        "Administra els comptes d'accés dels treballadors i treballadores de l'Ajuntament. Alta, modificació i baixa d'usuaris del sistema.",
      link: '/users/grid'
    },
    {
      icon: <LuClipboardList size={28} />,
      title: 'Tràmits i Expedients',
      description:
        "Accedeix a la seu electrònica per consultar i gestionar tràmits, sol·licituds i expedients municipals en curs.",
      link: 'https://santamargaridaielsmonjos.eadministracio.cat/info.0'
    },
    {
      icon: <LuBuilding2 size={28} />,
      title: 'Padró Municipal',
      description:
        "Informació sobre com tramitar amb l'Ajuntament: altes, baixes i modificacions al padró municipal d'habitants.",
      link: 'https://www.santamargaridaielsmonjos.cat/ajuntament/com-tramitar-amb-l-ajuntament'
    },
    {
      icon: <LuWallet size={28} />,
      title: 'Gestió Tributària',
      description:
        'Taxes, impostos i ordenances fiscals del municipi. Consulta el calendari fiscal i la gestió econòmica municipal.',
      link: 'https://www.santamargaridaielsmonjos.cat/ajuntament/gestio-tributaria'
    },
    {
      icon: <LuFileText size={28} />,
      title: 'Processos Selectius',
      description:
        "Consulta les convocatòries de selecció de personal de l'Ajuntament i el procés d'estabilització en curs.",
      link: 'https://www.santamargaridaielsmonjos.cat/ajuntament/processos-selectius'
    },
    {
      icon: <LuLeaf size={28} />,
      title: 'Medi Ambient',
      description:
        "Serveis ambientals del municipi: residus, espais verds, qualitat de l'aire i sostenibilitat. Consulta la web municipal.",
      link: 'https://www.santamargaridaielsmonjos.cat/serveis/medi-ambient'
    }
  ]

  return (
    <section className="bg-white h-fit dark:bg-gray-900">
      <div className="container px-6 py-10 mx-auto h-fit">
        <h1 className="text-2xl font-semibold text-gray-800 lg:text-3xl dark:text-white">
          Benvingut/da,{' '}
          <span className="underline decoration-[#006F53]">
            {user?.first_name + ' ' + user?.last_name}
          </span>
          !
        </h1>

        <p className="mt-3 text-gray-500 dark:text-gray-300">
          Plataforma de gestió interna de l&apos;Ajuntament de Santa Margarida i els Monjos.
          Selecciona un apartat per començar.
        </p>

        <DashboardComp cards={cards} />
      </div>
    </section>
  )
}
